import Column from '@components/Column';
import Loading from '@components/Loading';
import Row from '@components/Row';
import useItemCategories from '@hooks/category/useItemCategories';
import { Dispatch, SetStateAction, useContext } from 'react';

import ItemCategory from './ItemCategory';
import ItemFilters from './ItemFilters';
import styles from './styles.module.scss';
import ShopItemContext from '../../../../context/ShopItemContext';

interface Props {
    columns: number;
    setColumns: Dispatch<SetStateAction<number>>;
}

function ItemCategories({ columns, setColumns }:Props) {
  const { shopId } = useContext(ShopItemContext);
  const { categories, isLoading } = useItemCategories(shopId);
  return (
        <Column fullWidth>
            {isLoading && (
                <Loading size='small' />
            )}
            <Row className={styles.container} spacing={8} fullWidth>
                <ItemFilters columns={columns}
                             setColumns={setColumns} />
                <Row spacing={8} className={styles.categories}>
                    {categories?.map((category) => (
                        <ItemCategory key={category.id}
                                      categories={categories}
                                      itemCategory={category}/>
                    ))}
                </Row>
            </Row>
        </Column>
  );
}

export default ItemCategories;
